import { render, staticRenderFns } from "./PlayerButton.vue?vue&type=template&id=5271ae20&scoped=true&"
import script from "./PlayerButton.vue?vue&type=script&lang=js&"
export * from "./PlayerButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayerButton.vue?vue&type=style&index=0&id=5271ae20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271ae20",
  null
  
)

export default component.exports